"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _methods = require("./methods");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createUtilities = function createUtilities(store, modules) {
  var returnedActionArray = (0, _methods.getActions)(store);
  var returnedStateKeys = (0, _methods.getStateKeys)(store);
  var returnedStoreData = (0, _methods.getCurrentStoreData)(store);

  var actionHelpers = _objectSpread({}, (0, _methods.createActionHelpers)(store));

  var reducerActionHelpers = _objectSpread({}, (0, _methods.createActionReducerHelpers)(modules));

  var utiltiesObject = {
    actions: actionHelpers,
    stateKeys: returnedActionArray,
    actionKeys: returnedStateKeys,
    reducerActions: reducerActionHelpers,
    storeData: returnedStoreData,
    moduleData: modules
  };
  return utiltiesObject;
};

var _default = createUtilities;
exports["default"] = _default;
module.exports = exports.default;